import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import Message from 'components/Message';
import { Card, CardTitle } from 'components/Card';
import { Button, Form, Input } from 'components/HookForm';
import { bem } from 'helpers/class-name';

import './PasswordFormSection.scss';

const { element } = bem('password-form-section');

const messages = defineMessages({
  changePW: {
    id: 'settings.password-form-section.change-pw',
    defaultMessage: 'Change password',
  },
  placeholderPW: {
    id: 'settings.password-form-section.placeholder-pw',
    defaultMessage: 'Type new password',
  },
  placeholderConfirm: {
    id: 'settings.password-form-section.placeholder-confirm',
    defaultMessage: 'Type it again',
  },
  errorRequired: {
    id: 'settings.password-form-section.error-required',
    defaultMessage: 'Password required',
  },
  errorShort: {
    id: 'settings.password-form-section.error-short',
    defaultMessage: 'Password can’t be less than 6 symbols',
  },
  errorLong: {
    id: 'settings.password-form-section.error-long',
    defaultMessage: 'Password can’t be more than 25 symbols',
  },
  errorMismatch: {
    id: 'settings.password-form-section.error-mismatch',
    defaultMessage: 'Passwords must match',
  },
});

export const PasswordSection = ({ onSubmit }) => (
  <>
    {
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a className={element('anchor')} id="change-password" />
    }
    <Card>
      <Message as={CardTitle} message={messages.changePW} />
      <Form useFormOverrides={{ mode: 'onTouched' }} onSubmit={onSubmit}>
        {({ getValues }) => (
          <div className="grid">
            <Input
              className="grid__item sm-1/2"
              name="password"
              type="password"
              placeholder={messages.placeholderPW}
              autoComplete="new-password"
              required={messages.errorRequired}
              minLength={{ value: 6, message: messages.errorShort }}
              maxLength={{ value: 25, message: messages.errorLong }}
            />
            <Input
              className="grid__item sm-1/2"
              name="repeatPassword"
              type="password"
              placeholder={messages.placeholderConfirm}
              autoComplete="new-password"
              validate={{ value: value => value === getValues('password'), message: messages.errorMismatch }}
            />
            <div className="grid__item text--right">
              <Message as={Button} className="bt--width-lg" type={Button.TYPES.SUBMIT} message={messages.changePW} />
            </div>
          </div>
        )}
      </Form>
    </Card>
  </>
);

PasswordSection.propTypes = {
  onSubmit: PropTypes.func,
};

export default PasswordSection;
